import React, { Component } from "react";
import L from "leaflet";
import _ from "lodash";
import moment from "moment";
import { history } from "../../_helpers";

import "./index.css";

class ActionCountMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItems: this.props.dataItems,
    };
  }

  componentDidMount = () => {
    fetch("/data/rail_centreline.geojson")
      .then(response => {
        return response.json();
      })
      .then(json => {
        fetch("/data/stationBoxes_polygon.geojson")
          .then(response => {
            return response.json();
          })
          .then(json1 => {
            this.setState(() => {
              return {
                railLineGeojson: json,
                stationBoxGeojson: json1
              };
            });
          }).then(() => {
            if (this.checkMapContainer()) {
              this.initMap();
            }
          });
      });
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.dataItems !== nextProps.dataItems) {
      this.setState({
        dataItems: nextProps.dataItems,
      });
      const { map } = this.state;
      if (map) {
        this.renderMarkers(nextProps.dataItems);
      }
    }
  }

  checkMapContainer = () => {
    //check if map container exist
    const mapEle = document.getElementById("actionmap");
    if (mapEle !== null && !this.state.map) {
      return true;
    } else {
      return false;
    }
  }

  pointToLayer = (feature, latlng) => {
    return L.marker(latlng, { icon: this.setDeviceIcon(feature) });
  };

  setDeviceIcon = (e) => {
    const alertCount = e.properties.alertCount ? "<i class='clusterDot'></i>" : "";

    return L.divIcon({
      html: "<div class='markerIcon " + e.properties.icon + "'>" + alertCount + "</div>",
      iconSize: [24, 30],
      shadowSize: [24, 30],
      iconAnchor: [12, 29],
      className: "marker " + e.properties.status,
    });
  };

  initMap = () => {
    const center = [-37.814, 144.96332];
    const railLineStyle = {
      color: "#00bad4",
      weight: 1.5
    };

    const stationBoxStyle = {
      color: "#e52923",
      fillColor: "#e52923",
      weight: 1,
      fillOpacity: 0.9
    };
    const basemap = L.map("actionmap", { zoomControl: true }).setView(center, 14);
    // set map control location
    basemap.zoomControl.setPosition("bottomright");

    //Setting the base layer for the map
    L.tileLayer("https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png", {
      attribution: `&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>
          &copy; <a href="http://cartodb.com/attributions">CartoDB</a>`,
      subdomains: "abcd",
      maxZoom: 19
    }).addTo(basemap);

    //Adding rail line to the map layer
    L.geoJSON(this.state.railLineGeojson, {
      style: railLineStyle
    }).addTo(basemap);

    //Adding station boxes to the map layer
    L.geoJSON(this.state.stationBoxGeojson, {
      style: stationBoxStyle
    }).addTo(basemap);

    // set the map object
    this.setState(() => {
      return {
        map: basemap
      };
    });
    const dataItems = this.state.dataItems;
    if (dataItems.length > 0) {
      this.renderMarkers(dataItems);
    }
  };

  renderMarkers = (dataItems) => {
    const { map } = this.state;
    let devicesPoints = {};

    //create list of feature points for devices
    if (dataItems !== undefined && dataItems.length > 0) {
      devicesPoints = dataItems.filter(d => d.location).map(d => ({
        type: "Feature",
        properties: {
          id: d.id,
          type: "device",
          name: d.name,
          count: d.open_alert_count,
          status: d.status,
          icon: d.icon,
          alertCount: d.alertCount,
        },
        geometry: {
          type: "Point",
          coordinates: [d.location.longitude, d.location.latitude]
        }
      }));
    }

    //Adding the devices layer from the geojson
    const devicesLayer = L.geoJSON(
      {
        type: "FeatureCollection",
        features: devicesPoints
      },
      {
        pointToLayer: this.pointToLayer,
        onEachFeature: this.onEachFeature
      }
    );

    if (this.state.deviceClusterLayer) {
      map.removeLayer(this.state.deviceClusterLayer);
    }
    //generating the cluster layers for devices
    const devicemarkers = L.markerClusterGroup({
      maxClusterRadius: 50,
      iconCreateFunction: function (cluster) {
        const markerChild = cluster.getAllChildMarkers();
        // find if cluster child has alerts
        const haveAlertCount = _.find(markerChild, item => {
          return item.feature.properties.alertCount > 0;
        });
        const clusterDot = haveAlertCount ? "<i class='clusterDot'></i>" : "";
        return L.divIcon({
          html: "<div>" + clusterDot + "<span>" + cluster.getChildCount() + "</span></div>",
          iconSize: [40, 40],
          className: "marker-cluster-small marker-cluster",
        });
      }
    });
    devicemarkers.addLayer(devicesLayer);

    //adding the devices cluster layer
    map.addLayer(devicemarkers);

    // set the marker object
    this.setState(() => {
      return {
        deviceClusterLayer: devicemarkers
      };
    });
    if (dataItems.length > 0) {
      map.fitBounds(devicemarkers.getBounds());
    }
  };

  onEachFeature = (feature, layer) => {
    //bind click on each feature to open a sidebar
    layer.on({
      click: this.onMarkerClick
    });

    /*const barChart = 
      "Dosage proximity \
      <div class='barChart'> \
        <span class='number'>22</span> \
        <span class='bar' style='width: 80%'></span> \
        <span class='line'></span> \
      </div>";*/
    //bind tooltip on hovering over a feature
    const counter = "<span class='tooltip-count " + feature.properties.status + "'>" + feature.properties.alertCount + "</span> alerts";

    const str =
      "<div class='actionCountMapTooltip'><b class='tooltip-name'>" +
      feature.properties.name +
      "</b><div class='tooltip-con'>"
      // Remove Dosage proximity for now as backend not supporting yet.
      // + barChart 
      + counter +
      "</div></div>";

    layer.bindTooltip(str, { offset: L.point({ x: 0, y: -28 }), className: "mapTooltips", direction: "top" });
  };

  /* function to handle marker click */
  onMarkerClick = e => {
    const { id } = e.target.feature.properties;
    const period_start = "&start_time=" + encodeURIComponent(moment(this.props.period_start).toISOString());
    history.push("/alerts?devices=" + id + period_start);
  }

  render() {
    const { dataItems } = this.props;

    if (!dataItems) {
      return null;
    }

    return (
      <div id="actionmap" className="actionmap" />
    );
  }
}

export default ActionCountMap;



// WEBPACK FOOTER //
// ./src/_components/DashboardActionCountMap/actionCountMap.js